const steps = [
  {
    num: "01",
    title: "Send Your File",
    body: "Drop us a DXF, STEP, SVG, AI, or even a PDF sketch. No file? Describe what you need on the call.",
  },
  {
    num: "02",
    title: "Get a Quote",
    body: "Most quotes go out the same day. Transparent pricing — no surprises, no nickel-and-diming.",
  },
  {
    num: "03",
    title: "We Cut It",
    body: "Standard lead time is 1–5 business days. Need it faster? Ask about rush service.",
  },
  {
    num: "04",
    title: "Ship or Pick Up",
    body: "Local pickup in Southern California or we ship nationwide. Tracking included.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      className="border-b border-zinc-800 bg-zinc-950 py-20 sm:py-28"
      data-testid="process-section"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-14">
          <p className="font-mono-spec mb-3 text-orange-500">// 03 — How It Works</p>
          <h2 className="font-display text-5xl text-white sm:text-6xl lg:text-7xl">
            From File to Finished
            <br />
            <span className="text-zinc-500">in 4 Steps.</span>
          </h2>
        </div>

        <ol className="grid border-l border-t border-zinc-800 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <li
              key={s.num}
              className="relative border-b border-r border-zinc-800 p-8"
              data-testid={`process-step-${i}`}
            >
              <span className="font-display text-7xl text-orange-500 sm:text-8xl">
                {s.num}
              </span>
              <h3 className="mt-4 font-display text-3xl text-white">
                {s.title}
              </h3>
              <p className="mt-3 text-zinc-400">{s.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
